import React from "react";
import { STATUS_META } from "../utils/constants";
import { formatMoney, truncate } from "../utils/format";

const servicesText = (job) =>
  (job.services || [])
    .map((service) => (service === "Other" && job.service_other ? `Other: ${job.service_other}` : service))
    .join(", ") || "N/A";

export default function JobTable({ list, loading, perms, onPage, onView, onEdit, onDelete, onNew }) {
  const { rows, total, filteredTotal, page, lastPage } = list;

  return (
    <section className="table-container-card">
      <div className="table-header-bar">
        <h2>Job Order Register</h2>
        <div className="table-view-toggle">
          <span className="count-badge">
            {filteredTotal === total ? `${total} orders found` : `${filteredTotal} of ${total} orders found`}
          </span>
        </div>
      </div>

      <div className={`table-responsive ${loading ? "table-loading" : ""}`}>
        <table className="job-table">
          <thead>
            <tr>
              <th>Job Order #</th>
              <th>Date</th>
              <th>Customer / Company</th>
              <th>Contact &amp; Phone</th>
              <th>Services</th>
              <th>Total Price</th>
              <th>Balance</th>
              <th>Status</th>
              <th className="text-right">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((job) => {
              const meta = STATUS_META[job.status] || STATUS_META.pending;
              const services = servicesText(job);
              return (
                <tr key={job.id}>
                  <td className="job-no-cell cell-jobno" data-label="Job Order #">{job.job_no}</td>
                  <td className="cell-date" data-label="Date">{job.order_date || "-"}</td>
                  <td className="cell-customer" data-label="Customer">
                    <div className="customer-name">{job.customer_name || "-"}</div>
                    <div className="contact-sub">{job.contact_person || ""}</div>
                  </td>
                  <td className="cell-contact" data-label="Contact">
                    <div>{job.mobile || "-"}</div>
                    <div className="contact-sub">{job.email || ""}</div>
                  </td>
                  <td className="cell-services" data-label="Services">
                    <span title={services}>{truncate(services, 35)}</span>
                  </td>
                  <td className="cell-price" data-label="Total Price">
                    <strong>{formatMoney(job.total_price, job.currency)}</strong>
                  </td>
                  <td className="cell-balance" data-label="Balance">
                    <span className={job.balance > 0 ? "red-text bold-text" : ""}>{formatMoney(job.balance, job.currency)}</span>
                  </td>
                  <td className="cell-status" data-label="Status">
                    <span className={`badge-status ${meta.badge}`}>{meta.label}</span>
                  </td>
                  <td className="cell-actions text-right" data-label="Actions">
                    <div className="action-buttons-cell">
                      <button type="button" className="btn-table-action" title="View & Print Document" onClick={() => onView(job)}>
                        👁️ View
                      </button>
                      {perms.update && (
                        <button type="button" className="btn-table-action" title="Edit Job Order" onClick={() => onEdit(job)}>
                          ✏️ Edit
                        </button>
                      )}
                      {perms.delete && (
                        <button
                          type="button"
                          className="btn-table-action"
                          title="Delete Order"
                          style={{ color: "#ef4444" }}
                          onClick={() => onDelete(job)}
                        >
                          🗑️ Delete
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {!loading && rows.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">📁</div>
          <h3>No Job Orders Found</h3>
          <p>Get started by registering a new job order with customer details, specifications and auto PDF generation.</p>
          {perms.add && (
            <button type="button" className="btn btn-primary" onClick={onNew}>
              + Create First Job Order
            </button>
          )}
        </div>
      )}

      {lastPage > 1 && (
        <div className="table-pager">
          <button type="button" className="btn btn-sm btn-secondary" disabled={page <= 1 || loading} onClick={() => onPage(page - 1)}>
            ‹ Prev
          </button>
          <span>
            Page {page} of {lastPage}
          </span>
          <button type="button" className="btn btn-sm btn-secondary" disabled={page >= lastPage || loading} onClick={() => onPage(page + 1)}>
            Next ›
          </button>
        </div>
      )}
    </section>
  );
}
